<template>
    <div class="settings">
        <h1>{{$t('rules.title')}}</h1>
        <automatic-rules :value="$store.state.settings.msgrules"></automatic-rules>
        <manual-rules :value="$store.state.settings.manualrules"></manual-rules>
        <blocked-senders></blocked-senders>
    </div>

</template>

<script>
import AutomaticRules from '@/components/automaticRules';
import ManualRules from '@/components/manualRules';
import BlockedSenders from '@/components/blockedSenders';

export default {
  name: 'rules',
  components: { AutomaticRules, ManualRules, BlockedSenders }
};
</script>

<style lang="scss">
    @import '../assets/bootstrap-style.scss';

</style>
